﻿import { ajaxPost } from '../../utils/ajax';
import divaLoader from './divaLoader.js';

export default {
    name: 'documents',
    props: ['blockid', 'viewmodel', 'signerror', 'approveerror'],
    components: {
        'diva-loader': divaLoader
    },
    created() {
    },
    mounted() {
        this.model = this.viewmodel;
        this.$store.watch(state => state.digitalvalidation.alertModal.show,
            (newState) => {
                if (newState === true) {
                    this.showPopUp = true;
                    this.$store.dispatch('hideModal');
                }
            });
        //this.$store.watch(state => state.digitalvalidation.pageLoader.showLoader,
        //    (newState) => {
        //        this.showLoader = newState;
        //});
    },
    computed: {
        approveAll: {
            get: function () {
                return this.model.subscriptions ? this.approved.length == this.model.subscriptions.length : false;
            },
            set: function (value) {
                var approved = [];

                if (value) {
                    this.model.subscriptions.forEach(function (sub) {
                        approved.push(sub.telephoneNumber);
                    });
                }

                this.approved = approved;
            }
        },
        notAllApproved: {
            get: function () {
                if (!this.approveAll)
                    return true;

                if (!this.conditionsAccepted && !this.viewmodel.isMaxCommitmentTimeInMonths)
                    return true;
                if (!this.B2BConditionsAccepted && this.viewmodel.isMaxCommitmentTimeInMonths)
                    return true;

                if (this.viewmodel.displayNumberPorting && !this.portingAccepted)
                    return true;

                return false;
            }
        }
    },
    data: () => ({
        model: {
            subscriptions: []
        },
        approved: [],
        conditionsAccepted: false,
        portingAccepted: false,
        showPopUp: false,
        B2BConditionsAccepted:false
    }),
    validations: {
        model: {
            subscriptions: {

            }
        },
        approved: {

        }
    },
    methods: {
        executeSigning: function (orderId, dealerCode, channelType) {
            var errorMessages =
                {
                    "sign": this.signerror,
                    "approve": this.approveerror
                };

            this.$store.dispatch('signNonPortingContracts',
                {
                    'orderId': orderId,
                    'dealerCode': dealerCode,
                    'channelType': channelType,
                    'errorMessages': errorMessages,
                    'loaderTitle': this.model.currentBlock.loaderTitle,
                    'loaderMessage': this.model.currentBlock.loaderMessage
                });
        },
        getContract: function (orderId, documentId, dealerCode, channelType, fileName, loaderTitle, loaderMessage, popupMessage) {
            this.$store.dispatch('getDivaContracts',
                {
                    'orderId': orderId,
                    'documentId': documentId,
                    'dealerCode': dealerCode,
                    'channelType': channelType,
                    'fileName': fileName,
                    'loaderTitle': loaderTitle,
                    'loaderMessage': loaderMessage,
                    'popupMessage': popupMessage
                });
        },
        navigate() {
            document.getElementById("digitalvalidation-form").submit();
        },
        closePopup: function () {
            this.showPopUp = false;
        }
    },
    ready: function () {
    }
}